import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { UmkreissucheService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [UmkreissucheService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class UmkreissucheServiceModule {}
